<template>
  <nav class="navbar navbar-expand-lg navbar-size">
    <img
      src="../assets/broggl.png"
      alt=""
      height="18"
      style="padding-left: 30px"
    />
    <button
      class="navbar-toggler button-mobile-view"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse item-list" id="navbarSupportedContent">
      <div class="page-list">
        <ul class="navbar-nav" v-if="isLead">
          <li class="nav-item">
            <router-link class="nav-link navbar-links" to="/home"
              >Home</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link navbar-links" to="/teams"
              >Teams</router-link
            >
          </li>
          <li class="nav-item">
            <div class="" id="navbarNavDropdown">
              <ul class="navbar-nav">
                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdownMenuLink"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Reports
                  </a>
                  <ul
                    class="dropdown-menu items-center justify-content-center"
                    aria-labelledby="navbarDropdownMenuLink"
                  >
                    <li>
                      <router-link
                        class="nav-link navbar-links text-center"
                        to="/team-report"
                        >Team Report</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        class="nav-link navbar-links text-center"
                        to="/people-report"
                        >People Report</router-link
                      >
                    </li>
                    <li class="nav-item">
                      <router-link
                        class="nav-link navbar-links text-center"
                        to="/time-booked-per-user"
                        >Time booked per User</router-link
                      >
                    </li>
                    <li class="nav-item">
                      <router-link
                        class="nav-link navbar-links text-center"
                        to="/time-spent-on-clients-by-projects"
                        >Time spent on clients by projects</router-link
                      >
                    </li>
                    <li v-if="isLead">
                      <router-link
                        class="nav-link navbar-links text-center"
                        to="/team-lead-report"
                        >Team Lead Report</router-link
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link navbar-links"
              to="/clients-profitability-report"
              >Profitability</router-link
            >
          </li>
        </ul>
      </div>
      <div class="rigth-side">
        <v-row>
          <v-col cols="6">
            <div class="search-div">
              <form class="form-inline">
                <input
                  class="form-control"
                  @focus="active = true"
                  @blur="unactive"
                  v-model="searchInput"
                  aria-expanded="false"
                  type="text"
                  autocomplete="off"
                  id="searchBarInput"
                  v-on:keyup="clientSearch"
                  placeholder="Search"
                  aria-label="Search"
                />
                <div class="drop" v-if="active">
                  <router-link
                    class="dropdown-item client-name-style client-name-spacing"
                    v-for="(client, index) in searchRes"
                    :key="index"
                    :to="'/client/' + client.ID"
                    >{{ client.Name }}
                    <span class="client-search-status">
                      - {{ client.Status }}</span
                    ></router-link
                  >
                </div>
              </form>
            </div>
          </v-col>
          <v-col cols="4">
            <span>
              <ul class="navbar-nav">
                <li class="nav-item dropdown">
                  <font-awesome-icon
                    :icon="['fas', 'filter']"
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="SearchFilterMenuLink"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  />
                  <ul
                    class="dropdown-menu dropdown-custom"
                    aria-labelledby="SearchFilterMenuLink"
                  >
                    <li class="dropdown-custom">
                      <v-switch
                        v-model="includeChurnedAccounts"
                        :label="`include churn: ${
                          includeChurnedAccounts === '1' ? 'yes' : 'no'
                        }`"
                        false-value="0"
                        true-value="1"
                      ></v-switch>
                    </li>
                  </ul>
                </li>
              </ul>
            </span>
          </v-col>
          <v-col cols="2">
            <ul class="navbar-nav">
              <li class="nav-item dropdown user-logo">
                <a
                  id="userDropdown"
                  style="color: black"
                  class="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  ><i class="fas fa-user fa-fw"
                /></a>
                <div
                  class="dropdown-menu dropdown-menu-right dropdown-custom"
                  aria-labelledby="userDropdown"
                >
                  <router-link class="dropdown-item" to="/settings">
                    Settings
                  </router-link>
                  <div class="dropdown-divider" />
                  <a class="dropdown-item" href="#" @click="logout">Logout</a>
                </div>
              </li>
            </ul>
          </v-col>
        </v-row>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import { useClientStore } from "../stores/client.js";
import { useUserStore } from "../stores/user";
import broggl from "../assets/broggl.png";
const clientStore = useClientStore();
const { searchRes, searchInput, includeChurnedAccounts } =
  storeToRefs(clientStore);
const { clientSearch } = clientStore;

const userStore = useUserStore();

const { user } = storeToRefs(userStore);

const isLead = document.cookie.split("_isLead=")[1];

function getImageUrl(name) {
  const baseUrl =
    process.env.NODE_ENV === "production" || process.env.NODE_ENV === "preprod"
      ? "/dist/assets/"
      : "/src/assets/";
  return baseUrl + name;
}
</script>

<script>
import { defineComponent } from "vue";
import router from "../router/index.js";

export default defineComponent({
  data() {
    return {
      active: false,
      params: {
        name: "",
      },
      status: 0,
      token: document.cookie.split("jwt=")[1],
      response: "",
      clients: {},
    };
  },
  setup() {
    return {
      searchRes,
      searchInput,
      clientSearch,
    };
  },
  methods: {
    unactive() {
      setTimeout(function () {
        this.active = false;
      }, 1000);
    },
    logout() {
      this.$cookies.set("jwt", "");
      this.$cookies.set("user", "");
      router.push("/");
    },
  },
});
</script>

<style lang="scss">
.item-list {
  @media (min-width: 1024px) {
    background-color: #ffffff;
    width: 10vw;
    z-index: 1000;
    margin-left: 2vw;
  }
}

.button-mobile-view {
  @media (min-width: 50px) {
    margin-left: 1vw;
  }
  @media (min-width: 768px) {
    margin-right: 1vw;
  }
}

.navbar-size {
  @media (min-width: 50px) {
    height: 10vh;
    width: 100vw;
  }
  @media (min-width: 768px) {
    height: 10vh;
    width: 100vw;
  }
  @media (min-width: 1024px) {
    height: 10vh;
    width: 100vw;
  }
  @media (min-width: 1440px) {
    height: 10vh;
    width: 100vw;
  }
}

.navbar-collapse.show {
  background-color: #ffffff;
  z-index: 1000;
  @media (min-width: 50px) {
    margin-top: 2vh;
    border-radius: 5%;
    -webkit-box-shadow: 0px 10px 13px -7px #000000,
      0px 50px 50px -7px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 10px 13px -7px #000000,
      0px 50px 50px -7px rgba(0, 0, 0, 0.25);
  }
  @media (min-width: 768px) {
    margin-top: 4vh;
    border-radius: 5%;
    -webkit-box-shadow: 0px 10px 13px -7px #000000,
      0px 50px 50px -7px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 10px 13px -7px #000000,
      0px 50px 50px -7px rgba(0, 0, 0, 0.25);
  }
  @media (min-width: 1024px) {
    margin-top: 10vh;
  }
  @media (min-width: 1280px) {
    margin-top: 10vh;
  }
  @media (min-width: 1440px) {
    margin-top: 7vh;
  }
}

.client-search-status {
  font-size: 12px;
  color: #b4bac6;
}

.drop {
  @media (min-width: 50px) {
    position: absolute;
    background-color: white;
    z-index: 1000;
    border-color: rgba(236, 240, 241, 0.3);
    box-shadow: 1px 1px 1px rgba(44, 62, 80, 0.2);
    text-align: left;
    left: 50%;
    transform: translateX(-50%);
    width: 90vw;
    margin-top: 5px;
    border-radius: 5px;
  }
  @media (min-width: 768px) {
    position: absolute;
    background-color: white;
    z-index: 1000;
    width: 90vw;
    max-height: 40vh;
    overflow-y: scroll;
    border-color: rgba(236, 240, 241, 0.3);
    box-shadow: 1px 1px 1px rgba(44, 62, 80, 0.2);
    text-align: left;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 5px;
  }
  @media (min-width: 1024px) {
    position: absolute;
    background-color: white;
    z-index: 1000;
    width: 33vw;
    max-height: 33vh;
    overflow-y: scroll;
    border-color: rgba(236, 240, 241, 0.3);
    box-shadow: 1px 1px 1px rgba(44, 62, 80, 0.2);
    text-align: left;
    border-radius: 5px;
  }
  @media (min-width: 1440px) {
    position: absolute;
    background-color: white;
    z-index: 1000;
    width: 33vw;
    max-height: 33vh;
    overflow-y: scroll;
    border-color: rgba(236, 240, 241, 0.3);
    box-shadow: 1px 1px 1px rgba(44, 62, 80, 0.2);
    margin: 10px;
    text-align: left;
    border-radius: 5px;
  }
}

li.nav-item {
  @media (min-width: 50px) {
    margin-left: 1vw;
    margin-right: 1vw;
  }
  @media (min-width: 768px) {
    margin-left: 1vw;
    margin-right: 1vw;
  }
  @media (min-width: 1024px) {
    margin-left: 1.2vw;
    margin-right: 1.2vw;
    text-align: center;
  }
  @media (min-width: 1024px) {
    margin-left: 1.5vw;
    margin-right: 1.5vw;
    text-align: center;
  }
}

.client-name-style {
  @media (min-width: 50px) {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

nav {
  // height: 65px;
  background-color: #ffffff;
  border-bottom: solid 1px #ebedf8;
  z-index: 1000;
}

ul.nav-item a {
  text-decoration: none;
  font-size: 15px;
  font-weight: normal !important;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  color: #1880e7 !important;
  @media (min-width: 1440px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}

.navbar-links {
  color: #6c757d;
  text-decoration: none;
  margin: 0px;
  font-size: 15px;
}

.navbar-links:hover {
  /* box-shadow: inset 0px -8px 0px #FE938C; */
  cursor: pointer;
}

#searchBarInput {
  @media (min-width: 50px) {
    width: 90vw;
    margin-left: 5vw;
  }
  @media (min-width: 768px) {
    width: 90vw;
    margin-left: 5vw;
    margin-right: 5vw;
  }
  @media (min-width: 1024px) {
    width: 16vw;
    margin-right: 5vw;
    margin-left: 5vw;
  }
  @media (min-width: 1440px) {
    width: 16vw;
    margin: 0 !important;
  }
}

.page-list {
  @media (min-width: 50px) {
    z-index: 1000;
    background-color: #ffffff;
  }
  @media (min-width: 768px) {
    z-index: 1000;
    background-color: #ffffff;
  }
  @media (min-width: 1024px) {
    z-index: 1000;
    background-color: #ffffff;
    top: 0;
  }
  @media (min-width: 1024px) {
    z-index: 1000;
    background-color: #ffffff;
    top: 0;
    width: 60vw;
    display: flex;
    flex-direction: row;
    //spread content around
    justify-content: space-between;
    align-items: center;
  }
}

.right-side {
  @media (min-width: 50px) {
    z-index: 1000;
    background-color: #ffffff;
  }
  @media (min-width: 768px) {
    z-index: 1000;
    background-color: #ffffff;
  }
  @media (min-width: 1024px) {
    z-index: 1000;
    flex: 1;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    //spread content around
    justify-content: space-between;
    align-items: center;
  }
}
.search-div {
  @media (min-width: 1024px) {
    float: left;
    position: relative;
    display: inline-block;
  }
  @media (min-width: 1440) {
    // make the search bar align with the navbar
    float: left;
    width: 5vw !important;
    position: relative;
    margin-left: 0.5vw;
  }
}
.button-right {
  @media (min-width: 1024px) {
    float: right;
  }
  @media (min-width: 1440px) {
    width: 13vw !important;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
.user-logo {
  @media (min-width: 1440px) {
    margin: 0 !important;
  }
}
.dropdown-custom {
  @media (min-width: 1024px) {
    right: 0 !important;
    left: auto !important;
    top: 100%;
    margin-top: 0.125rem;
    border-radius: 0.25rem;
    width: max-content;
    padding: 0.5vw;
  }
  @media (min-width: 1440px) {
    // align the dropdown menu with the user-logo icon
    right: 0 !important;
    left: auto !important;
    top: 100%;
    margin-top: 0.125rem;
    border-radius: 0.25rem;
    width: max-content;
  }
}
.client-name-spacing {
  @media (min-width: 1024px) {
    margin: 0.5vw;
  }
}
</style>
